import request from '@/utils/request'

// 查询商品列表
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询家政类型
export function queryHousekeepingType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品分类列表
export function listGoodsClasses(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/goodsClass.listGoodsClasses',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存购物车
export function saveStoreCart(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeCart.saveStoreCart',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存网站访问日志
export function saveWebsiteAccessLog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/websiteAccessLog.saveWebsiteAccessLog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}